import { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInputText } from '@hopskipdrive/react-components';
import { Email } from '@mui/icons-material';
import { Button } from '@rideiq/shared/components/Button';
import { PageHeading } from '@rideiq/shared/components/PageHeading';
import { FormA11yErrorAnnouncer } from '@rideiq/shared/features/FormA11yErrorAnnouncer';
import { AnyObjectSchema } from 'yup';

import { ContainerForBanner, StyledAction } from './styles';

export interface ForgotPasswordProps {
  validationSchema?: AnyObjectSchema;
  handleSendInstructions: (data: FormData, e) => void;
}

type FormData = {
  email: string;
};

export const ForgotPasswordForm: FC<ForgotPasswordProps> = ({ validationSchema, handleSendInstructions }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    ...(validationSchema && { resolver: yupResolver(validationSchema) }),
  });

  return (
    <ContainerForBanner>
      <PageHeading variant="h1">Forgot password?</PageHeading>
      <form className="form" onSubmit={handleSubmit(handleSendInstructions)}>
        <FormA11yErrorAnnouncer errors={errors} />
        <Controller
          name="email"
          control={control}
          render={({ field: { value, onChange } }) => (
            <FormInputText
              aria-label="Email Address"
              id="login-email"
              placeholder="Email Address"
              type="email"
              variant="outlined"
              icon={<Email />}
              error={!!errors.email}
              helperText={errors.email ? errors.email.message : ''}
              autoFocus
              value={value}
              onChange={onChange}
            />
          )}
        />

        <StyledAction>
          <Button type="submit" color="primary">
            Send Instructions
          </Button>
        </StyledAction>
      </form>
    </ContainerForBanner>
  );
};
